<template>
    <div class="page-wrap">
        <div style="width:100%" class="loginwrap">
            <el-row :gutter="20" type="flex" justify="space-between" align="bottom">
                <el-col :span="12">
                    <h2>{{ $t('auth.login.title') }}</h2>
                </el-col>
                <el-col :span="12" class="text-right" v-if="currentAward">
                    <router-link :to="registerLink" class="blacklink">
                        {{ $t('auth.register.title') }}
                    </router-link>
                </el-col>
            </el-row>
            <login-form
                :errors="authErrors"
                :loading="loading"
                @submit="onSubmit"
            />
        </div>
    </div>
</template>

<script>
import LoginForm from './LoginForm'

export default {
    name: 'Login',
    components: {LoginForm},
    props: {
        loginRedirect: {
            default: 'index',
            type: String
        }
    },
    data() {
        return {
            authErrors: {},
            loading: false,
        }
    },
    mounted: function () {
        if (this.$auth.user()) {
            this.redirectLogin();
        }
    },
    methods: {
        onSubmit(loginData) {
            this.loading = true
            let parentRouteName = this.$route.matched[1].name;
            this.$auth
                .login({
                    data: loginData,
                    redirect: null,
                    staySignedIn: loginData.remember_me
                })
                .then(() => {
                    this.redirectLogin()
                }, error => {
                    if (error.response.status === 422)
                        this.authErrors = error.response.data.errors
                })
                .finally(() => this.loading = false)
        },
        redirectLogin() {
            let parentRouteName = this.$route.matched[1].path;
            this.$router.push(parentRouteName);
        }
    }
}
</script>

<style scoped lang="scss">

</style>
